import { defineComponent as _defineComponent } from 'vue';
import { computed, nextTick, watch } from 'vue';
import { useActions, useGetters } from 'vuex-composition-helpers';
import LogRow from './LogRow.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RunDetails',
    props: {
        runId: null
    },
    setup(__props) {
        const props = __props;
        const { find: fetchLogs } = useActions('run-log', ['find']);
        const { find: getLogsFromStore } = useGetters('run-log', ['find']);
        function fetch() {
            fetchLogs({ query: { runId: props.runId, $sort: { date: -1 } } });
        }
        watch(() => props.runId, fetch, { immediate: true });
        const logs = computed(() => getLogsFromStore.value({
            query: {
                runId: props.runId,
                $sort: { date: 1 },
            }
        }).data.toSorted((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()));
        watch(logs, async () => {
            await nextTick();
            const elem = document.getElementById('logs');
            if (!elem)
                return;
            elem.scrollTop = elem.scrollHeight;
        }, { deep: true });
        return { __sfc: true, props, fetchLogs, getLogsFromStore, fetch, logs, LogRow };
    }
});
